import { Spin } from "antd";
import styled from "styled-components";
import { isEn } from "project-config/utils/env";

const LoadingWrapper = styled.div<{ isExisitText: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--main-color);
  .ant-spin-dot-item {
    background-color: var(--main-color);
  }
  .ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
    width: 200px;
    color: ${(p) => (p.isExisitText ? "#D4D4D4" : "var(--main-color)")};
    font-size: 16px;
    text-shadow: 0 0 BLACK;
    left: -94px;
    padding-top: 22px;
  }
`;
export default function Loading({ text }: { text?: string }) {
  return (
    <LoadingWrapper isExisitText={!!text}>
      <Spin
        size="large"
        tip={text ? text : isEn() ? "Loading..." : "加载中..."}
        style={{ color: "var(--main-color)" }}
      >
        {text && <div className="loading-content" />}
      </Spin>
    </LoadingWrapper>
  );
}
